"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadScript = void 0;
// @ts-nocheck
/**
 * Insert script element into HTML from provided src url
 * @param {string} src
 * @param {function} [cb] Function that runs on script load
 */
function LoadScript(src, cb = () => { }) {
    const script = document.createElement('script');
    script.async = true;
    script.onload = cb;
    script.src = src;
    document.head.appendChild(script);
}
exports.LoadScript = LoadScript;
//# sourceMappingURL=LoadContent.js.map